import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8f2cb66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col space-y-8 mt-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center font-medium text-lg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, [
  /*#__PURE__*/_createTextVNode("성별"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "flex items-center font-medium text-lg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, [
  /*#__PURE__*/_createTextVNode("크기"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-col items-start font-medium text-lg" }
const _hoisted_9 = { class: "flex-row flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, [
  /*#__PURE__*/_createTextVNode("지역"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_11 = { class: "w-10/12 h-full flex flex-wrap" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "ml-20 border px-4 py-2 border-zinc-200 rounded-md border-solid w-[80%] h-full flex items-center flex-wrap"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex w-full" }
const _hoisted_16 = { class: "pl-24 mt-4 text-sm font-medium" }
const _hoisted_17 = { class: "text-pada" }

import { ref, watch, computed } from 'vue';
import locations  from '@/assets/data/location.json'
import store from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'WriteAttribute',
  props: {
    selectedGender : String,
    selectedSize : String,
    selectedLocation : String,
    selectedLocationDetail : String,
    selectedSpecies : String
},
  emits: ['update:gender', 'update:size', 'update:location', 'update:locationDetail'],
  setup(__props, { emit: __emit }) {

const genderArr :String[]= ['미구분', '암컷', '수컷', '한쌍', '그룹'];
const sizeArr:String[]= ['베이비','아성체','준성체','성체'];
const locationArr = ['서울','경기','인천','강원','충북','충남','세종','대전','경북','경남','대구','울산','부산','전북','전남','광주','제주'];
const props = __props;


const selectedSpecies = ref(props.selectedSpecies);
const selectGender = ref(props.selectedGender);
const selectSize = ref(props.selectedSize);
const selectLocation = ref(props.selectedLocation);
const selctedDetail = ref(props.selectedLocationDetail);
const locationDetailArr = ref(locations[selectLocation.value]); // "강남구","강동구","강북구","강서구","관악구",
const isProducts = ref(false);

const emit = __emit;

const handleDetail = (btn) => {
  selctedDetail.value = btn
}

// 선택된 값이 변경될 때 부모 컴포넌트에 알림
const emitToParent = () => {
    emit('update:gender', selectGender.value);
    emit('update:size', selectSize.value);
    emit('update:location', selectLocation.value);
    emit('update:locationDetail', selctedDetail.value);
};

// props 값이 변경될 때 내부 상태를 업데이트
watch(() => props.selectedGender, (newValue) => {
  selectGender.value = newValue;
});
watch(() => props.selectedSize, (newValue) => {
  selectSize.value = newValue;
});
watch(() => props.selectedLocation, (newValue) => {
    selectLocation.value = newValue;
    locationDetailArr.value = locations[newValue]
});
watch(() => props.selectedLocationDetail, (newValue) => {
    selctedDetail.value = newValue;
});
watch(() => props.selectedSpecies, (newValue) => {
    selectedSpecies.value = newValue;
    if(newValue === '사육장' || newValue === '먹이' || newValue === '기타 용품' || newValue === '도서'){
        selectGender.value = '물건';
        selectSize.value = '';
        isProducts.value = true;
    } else {
        isProducts.value = false;
    }
});

const setSelection = (type, value) => {
  if (type === 'gender') {
        selectGender.value = value;
    } else if (type === 'size') {
        selectSize.value = value;
    } else if (type === 'location') {
        selctedDetail.value = null;
        selectLocation.value = value;
        locationDetailArr.value = locations[selectLocation.value];
  }
  emitToParent();
};


// 선택된 값이 변경될 때마다 emitToParent 함수를 호출
watch([selectGender, selectSize, selectLocation, selctedDetail ], emitToParent);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isProducts.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderArr, (btn, i) => {
            return _createElementVNode("button", {
              key: i,
              class: _normalizeClass(["h-8 px-4 rounded-full bg-[#f2f4f5] mr-3 text-sm text-def font-normal", {'isSelected' : selectGender.value === btn}]),
              onClick: () => setSelection('gender', btn)
            }, _toDisplayString(btn), 11, _hoisted_4)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (!isProducts.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sizeArr, (btn, i) => {
            return _createElementVNode("button", {
              key: i,
              class: _normalizeClass(["h-8 px-4 rounded-full bg-[#f2f4f5] mr-3 text-sm text-def font-normal", {'isSelected' : selectSize.value === btn}]),
              onClick: () => setSelection('size', btn)
            }, _toDisplayString(btn), 11, _hoisted_7)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locationArr, (btn, i) => {
            return _createElementVNode("button", {
              key: i,
              class: _normalizeClass(["h-8 px-4 rounded-full bg-[#f2f4f5] mr-3 text-sm mb-3 text-def font-normal", {'isSelected' : selectLocation.value === btn}]),
              onClick: () => setSelection('location', btn)
            }, _toDisplayString(btn), 11, _hoisted_12)
          }), 64))
        ])
      ]),
      (selectLocation.value !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationDetailArr.value, (btn, i) => {
              return (_openBlock(), _createElementBlock("button", {
                key: i,
                class: _normalizeClass(["h-6 mr-3 text-sm my-2 bg-red50 text-sub flex justify-start", { 'isDetail': selctedDetail.value === btn }]),
                onClick: ($event: any) => (handleDetail(btn))
              }, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(btn), 1)
              ], 10, _hoisted_14))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode("지역 : "),
        _createElementVNode("span", _hoisted_17, _toDisplayString(__props.selectedLocation) + " " + _toDisplayString(selctedDetail.value), 1)
      ])
    ])
  ]))
}
}

})